import { session_qqconnect } from "@tencent/midas-util"

export class QQConnectAccount {
  init(opt) {
    return new Promise((resolve, reject) => {
      if (opt.openid && opt.openkey) {
        let loginState = null
        if (opt.session_type == "kp_actoken") {
          loginState = new session_qqconnect({
            qq_appid: opt.qq_appid,
            openid: opt.openid,
            payToken: opt.openkey
          })
        } else if (opt.session_type == "kp_accesstoken") {
          loginState = new session_qqconnect({
            qq_appid: opt.qq_appid,
            openid: opt.openid,
            accessToken: opt.openkey
          })
        }
        resolve({ loginState: loginState })
      } else {
        reject("无登录态")
      }
    })
  }
}
